import * as $ from "jquery";
import axios from "axios";
import proj4 from "proj4";
import {register} from "ol/proj/proj4";
import {get as getProjection, toLonLat} from "ol/proj";
import {GeoJSON} from "ol/format";
import {nanoid} from "nanoid";
import {enableFormBack, handleValidationErrors, hideField, renderList, showField} from "../../../forms";
import {closeModal, openModal} from "../../../utilities";
import {toastAlert} from "../../../toastAlert";
import Spinner from "../../../spinner";
import {confirmModal} from "../../../confirmModal";
import {EpInventoryLocationPoints} from "../../../map/layers/inventory-location-points";

export const inventoryLocationPoints = (epMap) => {
    // add/edit location points form
    const locationPointForm = $('#locationPointForm');
    const form = $('body').find('#addLocation, #editLocation');

    const container = $('[data-app-map_interaction_container="points"]')
    const table = container.find('table').DataTable()

    // locations layer
    let locationPointLayer = new EpInventoryLocationPoints(epMap.map)
    epMap.addCustomLayer(locationPointLayer);
    epMap.hideLabelsIfNecessary(locationPointLayer);

    $('[data-app_point_id]').each(function() {
        let id = $(this).data('app_point_id');

        let feature = locationPointLayer.addFeature([
            parseFloat(String($(`[name="points[${id}][longitude]"]`).val())),
            parseFloat(String($(`[name="points[${id}][latitude]"]`).val()))
        ]);

        feature.set('id', id);
        feature.set('name', $(`[name="points[${id}][name]"]`).val());
        feature.set('type', 'location_point');
    })

    $('[data-app-map_interaction_button="points"]').click(function() {
        const modal = $('#pointModal');

        modal.find('.modal-title').text('Dodawanie punktu');

        modal.find('[name="id"]').val('')
        modal.find('[name="name"]').val('')
        modal.find('[name="latitude"]').val('')
        modal.find('[name="longitude"]').val('')
        modal.find('[name="is_new"]').val(true)

        openModal('#pointModal');
    })

    table.on('click', '.btnEditPoint', function() {
        const modal = $('#pointModal');

        modal.find('.modal-title').text('Edycja punktu');

        const id = $(this).attr('data-id');

        const name = $(`[name="points[${id}][name]"]`).val();
        const latitude = $(`[name="points[${id}][latitude]"]`).val();
        const longitude = $(`[name="points[${id}][longitude]"]`).val();
        const isNew = $(`[name="points[${id}][is_new]"]`).val();

        modal.find('[name="id"]').val(id)
        modal.find('[name="name"]').val(name)
        modal.find('[name="latitude"]').val(latitude)
        modal.find('[name="longitude"]').val(longitude)
        modal.find('[name="is_new"]').val(isNew)

        openModal('#pointModal');
    })

    table.on('click', '.btnDeletePoint', async function() {
        if(await confirmModal('Czy na pewno chcesz usunąć ten punkt?')) {
            const id = $(this).attr('data-id');

            let feature = locationPointLayer
                .getSource()
                .getFeatures()
                .find(feature => feature.get('id') == id);

            if(feature) {
                locationPointLayer
                    .getSource()
                    .removeFeature(feature);
            }

            $(`[name="points[${id}][name]"]`).remove();
            $(`[name="points[${id}][latitude]"]`).remove();
            $(`[name="points[${id}][longitude]"]`).remove();
            $(`[name="points[${id}][is_new]"]`).remove();

            const row = table.$(`tr[data-id="${id}"]`);
            table.api().row(row).remove().draw();
        }
    })

    locationPointForm.submit(function(e) {
        e.preventDefault();

        let formData = new FormData(this);
        let id = nanoid();

        if(formData.get('id').length > 0) {
            // editing..
            id = formData.get('id');

            let feature = locationPointLayer
                .getSource()
                .getFeatures()
                .find(feature => String(feature.get('id')) === String(id));

            locationPointLayer
                .getSource()
                .removeFeature(feature)

            $(`[name="points[${id}][name]"]`).val(formData.get('name'))
            $(`[name="points[${id}][latitude]"]`).val(formData.get('latitude'))
            $(`[name="points[${id}][longitude]"]`).val(formData.get('longitude'))

            table.$(`tr[data-id="${id}"]`).find('.point-name').text(formData.get('name'))
        } else {
            form.append(`<input type="hidden" name="points[${id}][name]" value="${formData.get('name')}" />`)
            form.append(`<input type="hidden" name="points[${id}][latitude]" value="${formData.get('latitude')}" />`)
            form.append(`<input type="hidden" name="points[${id}][longitude]" value="${formData.get('longitude')}" />`)
            form.append(`<input type="hidden" name="points[${id}][is_new]" value="true" />`)

            let row = $(`
                <tr data-id="${id}">
                    <td class="point-name">${formData.get('name')}</td>
                    <td>
                        <button data-id="${id}" type="button" class="btn btn-sm btn-primary btnEditPoint">
                            Edytuj
                        </button>
                        <button data-id="${id}" type="button" class="btn btn-sm btn-danger btnDeletePoint">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            table.api().rows.add(row);
            table.api().draw();
        }

        let feature = locationPointLayer.addFeature([
            parseFloat(String(formData.get('longitude'))),
            parseFloat(String(formData.get('latitude')))
        ]);

        feature.set('id', id);
        feature.set('name', formData.get('name'));
        feature.set('type', 'location_point');

        enableFormBack(this);
        closeModal('#pointModal');
    })

    /// Import points
    let projection = null;
    $('#btnImportPointsSubmit').click(async function() {
        let spinner = new Spinner();

        let form = $("#importLocationPoints");

        if(!window.fileLists['files[]'] || window.fileLists['files[]'].length < 4) {
            spinner.destroy();
            toastAlert('Musisz dodać pliki SHP, SHX, PRJ oraz DBF', {type: 'danger'});
            return;
        }

        let formData = new FormData();
        let index = 0;
        for (let file of window.fileLists['files[]']) {
            if(file.uploaded) {
                continue;
            }

            formData.append('files#' + index, file);
            index++;
        }

        if(form.find('select option').length) {
            formData.append('field', form.find('select').val())
        }

        try {
            let response = await axios.post(form.attr('action'), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if(response.data.code !== 200) {
                if(response.data.code === 422) {
                    toastAlert('Wybierz kolumnę z nazwą punktu, a następnie kliknij "Importuj".')

                    let select = form.find('select');
                    select.empty();

                    for(let field of response.data.fields) {
                        select.append(`<option value="${field}">${field}</option>`)
                    }

                    $('#btnImportPointsSubmit').text('Importuj');
                    $('[data-app-file_container]').hide();

                    if(response.data.prj) {
                        proj4.defs('CUSTOM', response.data.prj);
                        register(proj4)
                        projection = getProjection('CUSTOM');
                    }

                    showField(form, 'field')
                } else {
                    handleValidationErrors(response.data.errors);
                }
            } else {
                for (let point of response.data.points) {
                    let feature = (new GeoJSON()).readFeature(point.geojson, {
                        dataProjection: projection,
                        featureProjection: 'EPSG:3857'
                    })

                    if(feature.getGeometry().getType() !== 'Point') {
                        continue;
                    }

                    let coordinates = toLonLat(feature.getGeometry().getCoordinates());
                    locationPointForm.find('[name="latitude"]').val(coordinates[1]);
                    locationPointForm.find('[name="longitude"]').val(coordinates[0]);
                    locationPointForm.find('[name="name"]').val(point.name);
                    locationPointForm.submit();
                }

                toastAlert('Pomyślnie zaimportowano punkty. Kliknij "Zapisz", aby zapisać zaimportowane punkty.')

                window.fileLists['files[]'] = [];
                renderList(form.find('[name="files[]"]'))
                $('#btnImportPointsSubmit').text('Wczytaj pliki');
                $('[data-app-file_container]').show();
                hideField(form, 'field')
                projection = null;

                closeModal('#importPointsModal');
            }
        } catch(err) {
            console.log(err)
            toastAlert('Wystąpił błąd podczas próby importu punktów.', {type: 'danger'});
        } finally {
            spinner.destroy()
        }
    })
}